import {XHRBackend, Http, RequestOptions} from "@angular/http";
import {InterceptedHttp} from "./http.interceptor";
import {TranslateServiceForm} from "../translate/translate.service";
import {Router} from "@angular/router";


export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions, _translate: TranslateServiceForm,  _router: Router): Http {
    return new InterceptedHttp(xhrBackend, requestOptions, _translate, _router);
}


// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/factory/http.factory.ts